import React, { useState } from 'react';
import ListSearch from '../components/Web/Search/ListSearch';


export default function Search(props) {
    const { location, history } = props;
    const [ data, setData ] = useState(null);

    return (
        <div>
            <ListSearch 
                data={data}
                setData={setData}
                location={location} 
                history={history}
            />
        </div>
    )
}
